var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useRef, useState } from "react";
import { useRetrievePlayerByUserId, useRetrieveTeamsByPlayerId, } from "./ApiProvider";
import Landing from "./Landing";
import { useRetrieveLeaguesByPlayerId } from "./api/LeagueApiProvider";
import { UserContext } from "./auth/UserProvider";
import { ErrorView } from "./nav/Error";
import { Loading } from "./nav/Loading";
import { OnboardingWizard } from "./onboarding/OnboardingWizard";
import { dismissOnboarding, isOnboardingDismissed, } from "./onboarding/onboardingDismissal";
import { PlayerPage } from "./players/PlayerPage";
var Home = function () {
    var _a = useContext(UserContext), contextUser = _a.user, isContextUserLoading = _a.loading;
    var _b = useRetrievePlayerByUserId({ userId: contextUser === null || contextUser === void 0 ? void 0 : contextUser.pk }), isPlayerLoading = _b.isLoading, playerError = _b.error, player = _b.data;
    var _c = useRetrieveTeamsByPlayerId({ playerId: player === null || player === void 0 ? void 0 : player.id }), _d = _c.data, teams = _d === void 0 ? [] : _d, isTeamsLoading = _c.isLoading;
    var _e = useRetrieveLeaguesByPlayerId({ playerId: player === null || player === void 0 ? void 0 : player.id }), _f = _e.data, leagues = _f === void 0 ? [] : _f, isLeaguesLoading = _e.isLoading;
    var _g = __read(useState(false), 2), dismissed = _g[0], setDismissed = _g[1];
    var onboardingStartedRef = useRef(false);
    var loading = isPlayerLoading ||
        isContextUserLoading ||
        isTeamsLoading ||
        isLeaguesLoading;
    if (!contextUser && !isContextUserLoading) {
        return _jsx(Landing, {});
    }
    if (loading) {
        return _jsx(Loading, {});
    }
    if (!player || playerError) {
        return _jsx(ErrorView, { error: new Error("Player not found") });
    }
    var isNewUser = teams.length === 0 && leagues.length === 0;
    var userPk = contextUser === null || contextUser === void 0 ? void 0 : contextUser.pk;
    var onboardingDismissed = dismissed || (userPk !== undefined && isOnboardingDismissed(userPk));
    // Latch onboarding once it starts: creating a team mid-flow flips isNewUser
    // to false (the new team invalidates the teams query), which would otherwise
    // tear the wizard down and drop the user on their read-only profile before
    // they reach the "create your profile" step.
    if (isNewUser && userPk !== undefined && !onboardingDismissed) {
        onboardingStartedRef.current = true;
    }
    if (onboardingStartedRef.current &&
        userPk !== undefined &&
        !onboardingDismissed) {
        return (_jsx(OnboardingWizard, { player: player, userPk: userPk, onDismiss: function () {
                dismissOnboarding(userPk);
                setDismissed(true);
            } }));
    }
    return _jsx(PlayerPage, { player: player, canViewTeams: true, canModify: true });
};
export default Home;
